<template>
  <app-layout>
     <template v-slot:headerTitle>
         <p>Settings</p>
    </template>
     <template v-slot:tallystatus>
          <div  v-show="tally_open_status=='false'">
                <i class="fa fa-times refresh" aria-hidden="true" ></i>
          </div>
           <div  v-show="tally_open_status=='true'">
                <i class="fas fa-check refresh" aria-hidden="true" ></i>
          </div>
     </template>
     <template v-slot:headerNav>
        <nav-items></nav-items>
     </template>
    <!-- <PageTitle :headerTitle="title"> </PageTitle> -->
          <br>
      <div class="">
    <div class="md:grid md:grid-cols-3 md:gap-6  ">
      <div class="md:col-span-1">
        <div class="px-4 sm:px-0">
          <h3 class="text-lg font-medium leading-6 text-gray-900 "> Tally Connection Setting</h3>
          <p class="mt-1 text-sm text-gray-600">
            Enter the required information need to connect tally.
          </p>
        </div>
      </div>
      <div class="mt-5 mx-10 md:mt-0 md:col-span-2">
        <form >
          <div class="shadow sm:rounded-md sm:overflow-hidden">
            <div class="px-4 py-5 bg-white space-y-6 sm:p-6">
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-3 sm:col-span-2">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th>Url</th>
                        <th>Template</th>
                        <th>Company Name</th>
                        <th>Valid From</th>
                        <th>Valid To</th>
                        <td>Delete</td>
                      </tr>
                    </thead>
                    <tbody v-for="(value,index) in this.settings_info_array">
                        <td>    
                          <DxSelectBox
                              :data-source="settingJson[0].type"
                              :value="value.type"
                              :accept-custom-value="true"
                              v-model:selectedItem="value.type"
                          />
                        </td>
                        <td>
                          <DxTextBox
                              v-model="value.url"
                          />
                        </td>
                        <td>
                          <DxSelectBox
                              :items="settingJson[1].template"
                              v-model="value.template"
                          />
                        </td>
                          <td>
                          <DxSelectBox
                              :items="company_names"
                              v-model:selectedItem="value.company_name"
                              :accept-custom-value="true"
                              :value="value.company_name"
                              @value-changed="setGuid($event,index)"
                          />
                        </td>
                        <td>
                          <DxDateBox
                              :items="settingJson[1].valid_from"
                              v-model:selectedItem="value.valid_from"
                              v-model="value.valid_from"
                          />
                        </td>
                        <td>
                          <DxDateBox
                              :items="settingJson[1].valid_to"
                              v-model:selectedItem="value.valid_to"
                              v-model="value.valid_to"
                          />
                        </td>
                        <td><button type="button" class="text-xs py-2 px-3 bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded" @click="removeInvoiceRow(index)"><i class="fas fa-minus" aria-hidden="true" ></i></button></td>
                    </tbody>
                  </table>
                  <button type="button" class="text-xs py-2 px-3 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" @click="addInvoiceRow"><i class="fas fa-plus" aria-hidden="true" ></i></button>
                  <div >
                  </div>
                </div>
              </div>
            </div>
            <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
              <jet-button type="button" @click="save_in_local" class="bg-blue-500 rounded  border rounded text-sm pl-2 pr-2 pt-1 pb-1 hover:no-underline"> refresh</jet-button>&nbsp;&nbsp;
              <jet-button type="button" @click="sync" class="bg-blue-500 rounded text-sm pl-2 pr-2 pt-1 pb-1 text-white hover:no-underline"> Update </jet-button>
            </div>
                <DxToast
                  v-model:visible="isVisible"
                  v-model:message="messag"
                  v-model:type="type"
                />
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="hidden sm:block" aria-hidden="true">
    <div class="py-5">
      <div class="border-t border-gray-200" />
    </div>
  </div>
<!-- Personal information -->
  <div class="mt-10 sm:mt-0">
    <div class="md:grid md:grid-cols-3 md:gap-6">
      <div class="md:col-span-1">
        <div class="px-4 sm:px-0">
          <h3 class="text-lg font-medium leading-6 text-gray-900">Personal Information</h3>
          <p class="mt-1 text-sm text-gray-600">
            Use a permanent address where you can receive mail.
          </p>
        </div>
      </div>
      <div class="mt-5 mx-10 md:mt-0 md:col-span-2">
        <form action="#" method="POST">
          <div class="shadow overflow-hidden sm:rounded-md">
            <div class="px-4 py-5 bg-white sm:p-6">
              <div class="grid grid-cols-6 gap-6">
              </div>
            </div>
            <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
              <button type="submit" class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  </app-layout>
</template>
<script>  
import DxDateBox from 'devextreme-vue/date-box';
import settingInfoJson from '../../../../../Products/Tallyclinic/Data/Json/syncJson.json';
import navItems from "@include/pages/modules/Components/nav_items";
import JetNavLink from '@/Jetstream/NavLink.vue';
import AppLayout from '@include/pages/BaseLayouts/tallyClinicAppLayout.vue';
import BsEdit from "@/Base/BsEdit.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import DxTextBox from 'devextreme-vue/text-box';
import DxSelectBox from 'devextreme-vue/select-box';
import { DxToast } from 'devextreme-vue/toast';
import {
    DxForm,
    DxSimpleItem,
    DxGroupItem,
} from 'devextreme-vue/form';
import {isElectron,getCompanyNamesWithIds} from "@include/pages/modules/UtilsJs/utils.js";
const modelData = {};
export default {
  props: {
    module_settings_data:[],
    id:'',
    createDef: Array,
    moduleRoute: String,
    moduleName:  String,
    modelData:{
        type: Object,
        default: () => ({})
    },
    settings_data:{
        type: Array,
        default: () => ({})
    }
  },
  components: {
    AppLayout,
    BsEdit,
    PageTitle,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxTextBox,
    JetNavLink,
    navItems,
    DxSelectBox,
    DxToast,
    DxDateBox
  },
  computed:{
      valueString(){
      let mod = JSON.stringify(this.settings_info_array, null, 2);
      return mod;
    },
  },
  data:function(){
    return{
        messag:'',
        type:'info',
        isVisible:false,
        settingJson:settingInfoJson,
        settings_info_array:[{"type":"","url":"","template":"","company_name":"","company_id":"","valid_from":"","valid_to":""}],
        settings_data:[],
        company_names:[],
        company_guids:[],
    }
  },
  methods:{
    addInvoiceRow(){
      this.settings_info_array.push({"type":"","url":"","template":""});
    },
    removeInvoiceRow(index){
      this.settings_info_array.splice(index,1)
    },
    sync(){
        //save settings data in server
        axios.post('/tallyclinicconfigurations',{settings_array_json:JSON.stringify(this.settings_info_array),id:this.id})
              .then((response)=>{
                if(response.status == 200){
                    this.messag = "Successfully Updated";
                    this.isVisible = true;  
                }
        })
    },
    save_in_local(){
        axios.get(route('configurations.data'))
            .then((response)=>{
                //save settings data in electron 
              if(isElectron()){
                window.api.send('save_settings_data',response.data.saved_settings_data); 
                window.api.receive("save_settings_data_reply", (Saving_res) => {
                    console.log(Saving_res);
                }); 
              }
            })
    },
    setGuid(e,index){
        var guid = '';
        this.company_guids.forEach(function(item,index){
          if(item.name == e.value){
            guid = item.guid;
          }
        })
        this.settings_info_array[index].company_id = guid;
        console.log(this.settings_info_array);
    },
  },
  mounted(){
    console.log()
    var _this = this;
    getCompanyNamesWithIds(_this);
  },
  created:function(){
    if(typeof this.module_settings_data == 'object' == true){
    }
    else{
       this.settings_info_array = JSON.parse(this.module_settings_data);
       console.log(this.settings_info_array);
    }
  }
} 
</script>
<style>
 .main-content {
        background-color: #f3f4f6;
            /* width: calc(100% - 250px); */
            /* height: 100vh; */
            margin-left: 212px;
            padding-bottom: 10px;
        } 
/* .edit_view{
height: 84vh;
} */
.container {
  margin-top:1rem;
}
p{
    margin-bottom: 0px;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}
.switch input {display:none;}
</style>